import {HttpClient} from './http-client';
import * as CONST_URL from './common-url';


export const RoyaltyService = {
    getRoyaltyYears: (userId) => {
      return HttpClient.get(CONST_URL.B2b_EXT(), {
        output: 'json',
        section: 'base',
        action:'royalty_statement_years',
        external_table: 'royalty_statement',
        external_user_id: userId
      });
    },

    getRoyaltiesByYear: (year,userId) => {
      return HttpClient.get(CONST_URL.B2b_EXT(), {
        output: 'json',
        number_format:'en_en',
        section: 'royalties',
        action: 'royalties_of_a_year',
        year: year,
        external_table: 'royalty_statement',
        external_user_id: userId
      });
    },

    getRoyaltyTopFifteenReports: (selected_royalty_period_id) => {
      return HttpClient.get(CONST_URL.B2b_EXT(), {
        output: 'json',
        section: 'base',
        action: 'royalty_top_15_report',
        channel: 'digital',
        limit: 15,
        royalty_period_id: selected_royalty_period_id
      });
    }

}